module.exports = __webpack_public_path__ + "img/login-bg-1.1bf23cfc.jpg";